"use client";

import { USER_INTERACTION_DATA_ATTRIBUTE_SPREAD_ME } from "@shared/constants";
// must render as a client component, otherwise there if there are no other client components that use fontawesome rendered on the page, the fontawesome styles will not be applied and you get a giant chevron
import type { ButtonHTMLAttributes } from "react";

import {
	ButtonContent,
	type CommonButtonProps,
	createButtonClassNames,
	determineIcon,
} from "./common-button-resources";

// We use type intersection here due to non-compatible overlap of color property types
type SimpleButtonProps = {
	text: string;
	iconLeftBandaid?: boolean;
} & CommonButtonProps &
	ButtonHTMLAttributes<HTMLButtonElement>;

// This button is not used often -- it's for edge cases where we don't want to submit a form or link to another page
// ex. the "Add another debt" button on the debt payoff calculator
export function SimpleButton({
	chevron,
	className,
	color,
	iconRight,
	size,
	text,
	type,
	variant,
	iconLeftBandaid,
	...rest
}: SimpleButtonProps) {
	const classNames = !className?.includes("financial-education-button")
		? createButtonClassNames({
				className,
				color,
				iconRight,
				size,
				variant,
			})
		: className;

	const icon = determineIcon({ chevron, iconRight });

	return (
		<button
			type={type || "button"}
			className={classNames}
			{...USER_INTERACTION_DATA_ATTRIBUTE_SPREAD_ME}
			{...rest}
		>
			{iconLeftBandaid && iconRight}
			<ButtonContent
				icon={icon}
				text={text}
				iconLeftBandaid={iconLeftBandaid}
			/>
		</button>
	);
}
